import { useEffect, useState } from "react"
import API from "./API"
import { AdminQueryCenter, AdminQueryDivision } from "../../backend/src/api/dto"
import { lookupNameFromObjectsArray } from "./global"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Centers() {

    const [data, setData] = useState<{
        centers: AdminQueryCenter[],
        divisions: AdminQueryDivision[]
    }>({
        centers: [],
        divisions: []
    })

    useEffect(() => {
        Promise.all([
            API.getCenters(),
            API.getDivisions()
        ]).then(res => {
            setData({
                centers: res[0],
                divisions: res[1]
            })
        })
    }, [])


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "arrows-to-circle"]} /> Strediská
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/center/center/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať stredisko</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Stredisko</th>
                                <th>Popis strediska</th>
                                <th>Divízia</th>
                                <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.centers.map(center => {
                                    return (
                                        <tr>
                                            <td>{center.name}</td>
                                            <td>{center.description}</td>
                                            <td>{lookupNameFromObjectsArray(data.divisions, 'divisionId', center.divisionId)}</td>
                                            <td className="text-center">{center.status ? <span className="text-success">Aktívne</span> : <span className="text-danger">Neaktívne</span>}</td>
                                            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/center/center/" + center.centerId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>


            <div className="card mt-5">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "sitemap"]} /> Divízie
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/center/division/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať divíziu</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Divízia</th>
                                <th>Popis</th>
                                <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.divisions.map(division => {
                                    return (
                                        <tr>
                                            <td>{division.name}</td>
                                            <td>{division.description}</td>
                                            <td className="text-center">{division.status ? <span className="text-success">Aktívna</span> : <span className="text-danger">Neaktívna</span>}</td>
                                            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/center/division/" + division.divisionId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Centers